import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
  styled,
  lighten,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import "react-toastify/dist/ReactToastify.css";
import grey from "@material-ui/core/colors/grey";
import axios from "axios";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Moment from "react-moment";
const StyledSubTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: grey[400],
  },
  body: {},
}))(TableCell);
const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});
export default function RowSampleFual(props) {

  const { row, data, getDownload, updateData, index } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();
  const selectAllParentCheckbox = () => {
    let rowdata = data;
    rowdata[index].checked = !rowdata[index].checked;
    rowdata.map((item) => {
      if (item.checked) {
        item.subReportDetails.map((i) => {
          i.checked = true;
        });
      } else {
        item.subReportDetails.map((i) => {
          i.checked = false;
        });
      }
    });
    updateData(rowdata);
  };
  const selectChildCheckbox = (id) => {
    let rowdata = data;
    let rowCount = 0;
    rowdata[index].subReportDetails[id].checked = !rowdata[index]
      .subReportDetails[id].checked;
    let uncheckeddata = rowdata[index].subReportDetails.filter(
      (item) => item.checked == false
    );
    if (uncheckeddata.length == rowdata[index].subReportDetails.length) {
      rowdata[index].checked = false;
    } else {
      rowdata[index].checked = true;
    }
    updateData(rowdata);
  };

  return (
    <React.Fragment>
      <TableRow className={clsx(classes.root)} >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.CustomerContract}
        </TableCell>
        <TableCell >
          {row?.VesselName }
        </TableCell>
        <TableCell >
          {/* {row.Dispatchport} */}
        </TableCell>
        <TableCell >
          {/* {row.SampledDate?(<Moment format="DD/MM/YYYY">{row.SampledDate}</Moment>):""} */}
        </TableCell>
        <TableCell>
          {/* {row.Status} */}
        </TableCell>
        {/* <TableCell padding="checkbox">
            <Checkbox
              checked={row.checked}
              onChange={selectAllParentCheckbox}
              inputProps={{ "aria-label": "select all desserts" }}
            />
          </TableCell> */}
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box mb={2}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <StyledSubTableCell>Sample Number</StyledSubTableCell>
                    <StyledSubTableCell>Vessel Name</StyledSubTableCell>
                    <StyledSubTableCell>
                      Bunker Port
                    </StyledSubTableCell>
                    <StyledSubTableCell>Fuel Grade</StyledSubTableCell>
                    <StyledSubTableCell>Report Type</StyledSubTableCell>
                    <StyledSubTableCell>Sampled Date </StyledSubTableCell>
                    <StyledSubTableCell>Arrived Date</StyledSubTableCell>
                    <StyledSubTableCell>Analysed Date</StyledSubTableCell>
                    <StyledSubTableCell>Reported Date</StyledSubTableCell>
                    <StyledSubTableCell>Status</StyledSubTableCell>
                    {/* <StyledSubTableCell padding="checkbox"></StyledSubTableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.SampleList.map((historyRow, i) => (
                    
                    <TableRow key={historyRow.SampleID} >

                      <TableCell> {historyRow.SampleID}</TableCell>
                      <TableCell> {row.VesselName}</TableCell>
                      <TableCell>{historyRow.BunkerPort}</TableCell>
                      <TableCell>{historyRow?.ProductType}</TableCell>
                      <TableCell>{historyRow.ReportType}</TableCell>
                      <TableCell>
                        {historyRow.SampledDate ? (<Moment format="DD/MM/YYYY">{historyRow.SampledDate}</Moment>) : ""}
                      </TableCell>
                      <TableCell>
                        {historyRow.ArrivedDate ? (<Moment format="DD/MM/YYYY">{historyRow.ArrivedDate}</Moment>) : ""}
                      </TableCell>
                      <TableCell>
                        {historyRow.AnalysedDate ? (<Moment format="DD/MM/YYYY">{historyRow.AnalysedDate}</Moment>) : ""}
                      </TableCell>
                      <TableCell>
                        {historyRow.ReportedDate ? (<Moment format="DD/MM/YYYY">{historyRow.ReportedDate}</Moment>) : ""}
                      </TableCell>
                      <TableCell>{historyRow.Status}</TableCell>
                      {/* <StyledTableCell padding="checkbox">
                          <Checkbox
                            onChange={() => {
                              selectChildCheckbox(i);
                            }}
                            checked={historyRow.checked}
                          />
                        </StyledTableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
